export const RESET_PASSWORD_EVENTS = {
    VIEW_RESET_PASSWORD_SCREEN: "view_reset_password_screen",
    SELECT_RESET_CHANGE_PASSWORD: "select_reset_change_password",
    VIEW_RESET_PASSWORD_SUCCESS_TOAST: "view_reset_password_success_toast",
    DEEP_LINK_CHECK_MOBILE: "deep_link_check_mobile"
} as const;